export default __webpack_public_path__ + "static/media/web-Bim-Share-2.21dd0763.png";